<script setup>
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();
</script>

<template>
  <transition name="fade">
    <div v-if="authStore.isAuthenticating" class="auth-loading-overlay">
      <div class="auth-loading-content">
        <img
          src="@/assets/images/group-logo.png"
          alt=""
          style="max-height: 67px"
        />
        <h4>Signing you in…</h4>
        <p>Please wait</p>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.auth-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.auth-loading-content {
  text-align: left;
}

.auth-loading-content h4 {
  margin-bottom: 0.5rem;
  color: #333;
}

.auth-loading-content p {
  color: #666;
  margin: 0;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
